define('modules/home/dashboard/views/search.result.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "modules/base/models/uniquify.companies.model",
    "text!modules/home/dashboard/templates/search.result.template.html"
], function(
    Prospector,
    $,_,Backbone,
    UniquifyCompaniesModel,
    Template
){
    var SearchResultView = Backbone.View.extend({
        className: 'searchResult col-xs-12 col-md-offset-0 col-md-2 animated fadeIn',
        template: _.template(Template),
        twoLineLimit: 60,
        events: function(){
            var base = {
            };
            var click = {
                'click' : 'procClickURL',
                'click .linkedIn'    : 'procLinkedIn'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options) {
            this.model = options.model;
            this.filter = options.filter;
            this.sequence = options.sequence;
            this.parent = options.parent;
        },
        render: function() {
            $(this.el).html(this.template());
            if(this.model.identityType == "person"){
                var firstName = this.getDisplayText("firstName");
                if(firstName.length < 2 && this.getDisplayText("middleName") != ""){
                    firstName += " " + this.getDisplayText("middleName");
                }
                this.$('.searchResultLine1').html(firstName + " " + this.getDisplayText("lastName"));
                this.$('.searchResultLine1').addClass('person_name');
                if(this.getDisplayText("role") == ""){
                    this.$('.searchResultLine2').html(this.getDisplayText("company"));
                } else {
                    this.$('.searchResultLine2').html(this.getDisplayText("role"));
                    var companyText = this.getDisplayText("company");
                    if(companyText != ""){
                        this.$('.searchResultLine3').html(companyText);
                        if(this.model.companyId != 0){
                            this.$('.person_company').addClass('clickable');
                        }
                    }
                }
                this.$('.profile_pic').addClass("relpro-person_silo");
                var posType = "";
                if (this.model.currentFlag == 0) {
                    posType = "";
                } else if (this.model.currentFlag == 1) {
                    posType = "Current position";
                } else {
                    posType = "Past position";
                }
                this.$('.searchResultLine4').html(posType)

                if(!this.model.hasDirectPhone && !this.model.hasCompanyPhone) {
                    this.$('.hasPhone').hide();
                }

                if(this.model.hasDirectPhone && this.model.hasCompanyPhone){
                    this.$('.hasPhone').attr("data-title", "Person has direct and company phone numbers.");
                    this.$('.hasPhone span').attr("class","relpro-sk relpro-sk-phone-direct");
                    this.$('.hasPhone').append('<span class="mLeft5 icon-phone"></span>');

                } else if(this.model.hasDirectPhone){
                    this.$('.hasPhone').attr("data-title", "Person has at least one direct phone numbers.");
                    this.$('.hasPhone span').attr("class","relpro-sk relpro-sk-phone-direct");

                } else if(this.model.hasCompanyPhone){
                    this.$('.hasPhone').attr("data-title", "Person has at least one company phone number.");
                    this.$('.hasPhone span').attr("class","icon-phone");
                }

                window.setTimeout($.proxy(function () {
                        if(this.model.hasDirectPhone || this.model.hasCompanyPhone){
                            this.$('.hasPhone').attr("data-toggle", "tooltip");
                            if(this.sequence > 0){
                                this.$('.hasPhone').attr("data-placement", "top");
                            } else {
                                this.$('.hasPhone').attr("data-placement", "bottom");
                            }
                            this.$('[data-toggle="tooltip"]').tooltip();
                        }
                    }, this
                ),1000);

                this.$('a.searchResultLine1').attr("href", "#" + this.buildURL());

                if (this.model.companyId != 0) {
                    this.$('a.searchResultLine3').attr("href", '#' + this.buildRelatedProfileURL());
                    this.$('a.searchResultLine3').addClass('clickable');
                }
                else {
                    this.$('a.searchResultLine3').css('textDecoration','none');
                }

                if(!Prospector.SettingsApp.hasLinkedIn()){
                    this.$('.hasLinkedIn').hide();
                }

            } else {
                this.$('.searchResultLine1').addClass('company_name');
                this.$('.searchResultLine1').html(this.getDisplayText("name"));
                var logoUrl = window.utils.identity.getDomain(this.model['headline']);
                if (logoUrl) {
                    this.$('.profile_pic').html('<img class="img-responsive companyLogo mBottom10" src="https://s3.amazonaws.com/relpro-company-logos/' + logoUrl + '.png">');
                } else {
                    this.$('.profile_pic').addClass("relpro-building");
                }
                var text = this.getDisplayText("city");
                if (text != "") {
                    if (this.getDisplayText("state") != "") text += ", " + this.getDisplayText("state");
                }
                this.$('.searchResultLine2').html(text);
                var headline = this.getDisplayText("headline");
                this.$('.searchResultLine3').html(headline);
                this.$('.searchResultLine4').html("Current RelPro People: " + window.utils.numberWithCommas(this.getDisplayText("numberIndividuals")));
                if(!this.model.hasPhoneNumbers){
                    this.$('.hasPhone').hide();
                }
                this.$('a.searchResultLine1').attr("href", "#" + this.buildProfileURL());

                this.$('.hasLinkedIn').hide();
            }
            if(!this.model.hasCV){
                this.$('.hasDetailedCV').hide();
            }
            if(!this.model.hasEMails){
                this.$('.hasEmail').hide();
            }
            if(!this.model.hasDirectPhone){
                this.$('.hasCompanyPhone').hide();
            }
            if(!this.model.hasCompanyPhone){
                this.$('.hasDirectPhone').hide();
            }
            if(!this.model.hasLocations){
                this.$('.hasLocation').hide();
            }

            var lastUpdated = this.model.lastUpdated;
            if(lastUpdated != undefined && lastUpdated != ""){
                lastUpdated = ' as of ' + lastUpdated;
            } else {
                lastUpdated = ""
            }

            this.$('.dataSourceLabel').html(window.utils.identity.makeSourceName(this.model.source.sourceId) + lastUpdated);
            this.$('img').on('error', $.proxy(this.replaceImage,this));

            return this;
        }, //end of render

        replaceImage:function(event){
            this.$(".profile_pic").html('<span class="relpro relpro-building"></span>');
        },

        getDisplayText:function(attr){
            var text = '';
            if(attr != undefined & attr != ""){
                text = this.model[attr];
            }
            return window.utils.makeElipsis(text, this.twoLineLimit);
        },

        buildURL:function(event){
            if(event != undefined && event.toElement && $(event.toElement).hasClass('clickable') ) {
                return this.buildRelatedProfileURL();
            } else {
                return this.buildProfileURL();
            }
        },

        buildProfileURL:function(event){
            var searchId = "";
            if(this.parent.contactSearchModel.has('searchId')){
                searchId = "?searchId=" + this.parent.contactSearchModel.get('searchId')
            }
            var sourceId = 0;
            var refId = this.model.rcpId == 0 ?  this.model.source.refId : this.model.rcpId;
            if(this.model.firstName != undefined){
                var identityType = "person";
                sourceId = this.model.rcpId == 0 ?  this.model.source.sourceId : 2311;
            } else {
                var identityType = "organization";
                sourceId = this.model.rcpId == 0 ? this.model.source.sourceId : 2312;
            }
            this.clickUrl = 'profile/' + identityType + '/' + sourceId + '/' + refId + searchId;
            return this.clickUrl;

        },
        buildRelatedProfileURL:function(event){
            var searchId = "";
            if(this.parent.contactSearchModel.has('searchId')){
                searchId = "?searchId=" + this.parent.contactSearchModel.get('searchId')
            }

            var identityType = "organization";

            var sourceId = this.model.source.sourceId != 1046 ? this.model.source.sourceId : 46;
            var refId = this.model.companyId;

            this.clickUrl =  'profile/' + identityType + '/' + sourceId + '/' + refId + searchId;
            return this.clickUrl;
        },
        procClickURL:function(event) {
            if(!$(event.toElement).hasClass('clickable')){
                var sourceId = 0;
                var refId = this.model.rcpId == 0 ?  this.model.source.refId : this.model.rcpId;

                if(this.model.firstName != undefined){
                    this.identityType = "person";
                    sourceId = this.model.rcpId == 0 ?  this.model.source.sourceId : 2311;
                } else {
                    this.identityType = "organization";
                    sourceId = this.model.rcpId == 0 ?  this.model.source.sourceId : 2312;
                }
                var identityType = "";
                if($(event.toElement).hasClass('clickable')){
                    identityType = "organization";
                    sourceId = this.model.source.sourceId != 1046 ? this.model.source.sourceId : 46;
                    refId = this.model.companyId;
                } else {
                    identityType = this.identityType;
                }
                var searchId = "";
                if(this.parent.contactSearchModel.has('searchId')){
                    searchId = "?searchId=" + this.parent.contactSearchModel.get('searchId')
                }

                this.clickUrl = 'profile/' + identityType + '/' + sourceId + '/' + refId + searchId;
                Backbone.history.navigate(this.clickUrl,true);
            }
        },
        procLinkedIn: function(){
            window.utils.identity.procLinkedIn(this.model);
        }
    });
    return SearchResultView;
});

